module.exports = __webpack_public_path__ + "static/media/success.f9ae764e.svg";